import { ActionTree } from 'vuex';
import {
  EUpdateGoogleDocsAction,
  EUpdateGoogleDocsMutation,
  state as defaultState,
} from './update-google-docs.constants';
import { IUpdateGoogleDocsState } from './update-google-docs.types';
import { DocumentService } from '@/api/documents/services/document.service';
import { DealroomHelper } from '@/dealroom/helpers/dealroom.helper';
import { translate } from '@/helpers/translation.helper';
import { RootState } from '@/store/store';
import { IDocumentPage } from '@/types/document-page';

export const actions: ActionTree<IUpdateGoogleDocsState, RootState> = {
  async [EUpdateGoogleDocsAction.LoadPage](
    { dispatch },
    { documentId, id }: { documentId: string; id: string }
  ) {
    try {
      const page: IDocumentPage = await DocumentService.loadDocumentPage(documentId, id);
      dispatch(EUpdateGoogleDocsAction.LoadPageSuccess, page);
    } catch (e) {
      dispatch(EUpdateGoogleDocsAction.LoadPageFailed, e.toString());
    }
  },
  [EUpdateGoogleDocsAction.LoadPageSuccess]({ commit, state }, page: IDocumentPage) {
    const statePages: IDocumentPage[] = [...state.importedPages];
    const totalPages: IDocumentPage[] = DealroomHelper.addDocumentPages([page], statePages);
    commit(EUpdateGoogleDocsMutation.SetPages, totalPages);
  },
  [EUpdateGoogleDocsAction.LoadPageFailed]({ commit }, error: string) {
    commit(
      EUpdateGoogleDocsMutation.SetError,
      translate('failed-to-import-google-document', { error })
    );
  },
  [EUpdateGoogleDocsAction.SetPageCount]({ commit }, pageCount: number) {
    commit(EUpdateGoogleDocsMutation.SetPageCount, pageCount);
  },
  [EUpdateGoogleDocsAction.Reset]({ commit }) {
    commit(EUpdateGoogleDocsMutation.SetState, { ...defaultState });
  },
};
